import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import reduce from 'lodash/reduce';

import styles from './main_nav.module.scss';

import Logo from './Logo';
import Menu from './Menu';
import Search from './Search';
import SimpleNav from './SimpleNav';
import StickyNav from './StickyNav';
import AffiliateNav from './AffiliateNav';

import urlMatchData from './data/urlMatchData';

class MainNav extends Component {
  constructor() {
    super();

    this.state = {
      activePrimaryTab: null,
      searching: false,
      showMobileMenu: false,
      mobileCollapsedMenu: null,
      showStickyNav: false,
    };
  }

  componentDidMount() {
    if (this.props.affiliateNav) {
      return;
    }

    const currentPath = window.location.pathname;

    const activeTab = reduce(urlMatchData, (res, data) => {
      let active = res;

      if (data.regex.test(currentPath)) {
        /* eslint-disable prefer-destructuring */
        active = data.active;
        /* eslint-enable prefer-destructuring */
      }

      return active;
    }, 'insurance');

    this.setActivePrimaryTab(activeTab);

    window.addEventListener('scroll', () => {
      let showStickyNav;
      const mainNavPageOffset = 800;
      const stickyNavPageOffset = 680;

      // The window pageYOffset varies depending on which
      // nav is displayed because they both have different
      // heights.
      if (this.state.showStickyNav) {
        showStickyNav = window.pageYOffset >= stickyNavPageOffset;
      } else {
        showStickyNav = window.pageYOffset >= mainNavPageOffset;
      }
      this.setState({
        showStickyNav: this.props.stickyNavProps && showStickyNav,
      });
    });
  }

  shouldComponentUpdate() {
    return typeof this.props.affiliateNav === 'undefined';
  }

  setActivePrimaryTab = (activePrimaryTab) => {
    this.setState({ activePrimaryTab });
  }

  setMobileCollapsedMenu = (mobileCollapsedMenu) => {
    this.setState({ mobileCollapsedMenu });
  }

  toggleMobileMenu = (toggle) => {
    this.setState({
      mobileCollapsedMenu: null,
    });

    // prevents document behind mobile nav menu from scrolling
    if (toggle) {
      document.body.style.margin = 0;
      document.body.style.height = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.margin = '';
      document.body.style.height = '';
      document.body.style.overflow = '';
    }

    this.setState({
      showMobileMenu: toggle
    });
  }

  toggleSearching = (toggle) => {
    this.setState({ searching: toggle });
  }

  renderFullNav() {
    const mainPanelClasses = classnames(
      styles['main-panel'],
      this.state.searching && styles.searching,
      this.state.showMobileMenu && styles['show-mobile-menu']
    );

    const showStickyNavClasses = classnames(
      this.state.showStickyNav && styles['show-nav'],
      !this.state.showStickyNav && styles['hide-nav'],
    );

    const showMainNavClasses = classnames(
      styles.wrapper,
      styles['main-nav'],
      this.state.showStickyNav && styles['hide-nav'],
      !this.state.showStickyNav && styles['show-nav'],
    );

    return (
      <React.Fragment>
        <nav className={showMainNavClasses}>
          <div className={mainPanelClasses} style={{ zIndex: '100' }}>
            <div className={styles.container}>
              <Logo className={styles.logo} />
              <div className={styles['panel-wrapper']}>
                <Menu
                  setActivePrimaryTab={this.setActivePrimaryTab}
                  setMobileCollapsedMenu={this.setMobileCollapsedMenu}
                  {...this.state}
                  subMenuSecondaryBackground={this.props.subMenuSecondaryBackground} // Experiment CH28357 -- Remove this line if experiment loses
                />
                <Search
                  searching={this.state.searching}
                  toggleSearching={this.toggleSearching}
                  toggleMobileMenu={this.toggleMobileMenu}
                  showMobileMenu={this.state.showMobileMenu}
                  setActivePrimaryTab={this.setActivePrimaryTab}
                />
              </div>
            </div>
          </div>
        </nav>
        <div className={showStickyNavClasses}>
          <StickyNav {...this.props.stickyNavProps} />;
        </div>
      </React.Fragment>
    );
  }

  renderSimpleNav() {
    const mainPanelClasses = classnames(
      styles['main-panel'],
      styles['simple-panel'],
      this.state.searching && styles.searching,
      this.state.showMobileMenu && styles['show-mobile-menu']
    );

    const showStickyNavClasses = classnames(
      this.state.showStickyNav && styles['show-nav'],
      !this.state.showStickyNav && styles['hide-nav'],
    );

    return (
      <React.Fragment>
        <nav className={styles.wrapper}>
          <div className={mainPanelClasses} style={{ zIndex: '100' }}>
            <div className={styles.container}>
              <Logo className={styles.logo} />
              <div className={styles['panel-wrapper']}>
                <SimpleNav {...this.props} />
              </div>
            </div>
          </div>
        </nav>
        <div className={showStickyNavClasses}>
          <StickyNav {...this.props.stickyNavProps} />;
        </div>
      </React.Fragment>
    );
  }

  render() {
    const {
      simpleNav,
      affiliateNav,
      fields,
    } = this.props;

    switch (true) {
      case typeof affiliateNav !== 'undefined':
        return (<AffiliateNav {...fields} />);
      case simpleNav:
        return this.renderSimpleNav();
      default:
        return this.renderFullNav();
    }
  }
}

MainNav.propTypes = {
  simpleNav: PropTypes.bool,
  affiliateNav: PropTypes.bool,
  fields: PropTypes.object,
  stickyNavProps: PropTypes.shape({
    formType: PropTypes.string.isRequired,
    actionPath: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    inputName: PropTypes.string,
    buttonText: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    inputType: PropTypes.string,
    label: PropTypes.string.isRequired,
    mobileLabel: PropTypes.string.isRequired,
    className: PropTypes.string
  }),
  subMenuSecondaryBackground: PropTypes.bool, // Experiment CH28357 -- Remove this line if experiment loses
};

export default MainNav;



// WEBPACK FOOTER //
// ../src/templates/MainNav/index.js